import React,{useEffect,useState} from 'react'
import {Link} from "react-router-dom";
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
// import axios from "axios";
import axios from "../helper/axios";
import {useSelector,useDispatch} from "react-redux";
import {CopyToClipboard} from 'react-copy-to-clipboard';


export default function ProductList() {
  const [allProduct,setAllProduct] = useState([]);
  const [ copied, setCopied] = useState(false);
  const auth = useSelector(state=>state.auth);

  const apiData=async()=>{ 
    const res= await axios.post("/getbanner"); 
    if(res.status===200){
      const data = res?.data;
      setAllProduct(Array.isArray(data) ? data : (data ? [data] : []));
    } else {
      setAllProduct([]);
    }
  }

  const deleteBanner = async (bannerId) => {
    if (!bannerId) return;
    if (window.confirm("A jeni të sigurt që dëshironi të fshini këtë baner? File-i fizik do të fshihet gjithashtu.")) {
      try {
        const res = await axios.post("/deletebanner", { bannerId });
        if (res.status === 200) {
          alert("Baneri u fshi me sukses!");
          apiData();
        } else {
          alert("Ka pasur problem me fshirjen e banerit!");
        }
      } catch (error) {
        console.error("Error deleting banner:", error);
        alert("Ka pasur një gabim gjatë fshirjes së banerit!");
      }
    }
  }

  const setMainBanner = async (bannerId) => {
    if (!bannerId) return;
    try {
      const res = await axios.post("/setmainbanner", { bannerId });
      if (res.status === 200) {
        alert("Baneri u vendos si kryesor (do të shfaqet i pari).");
        apiData();
      } else {
        alert("Ka pasur problem.");
      }
    } catch (error) {
      console.error("Error setting main banner:", error);
      alert("Ka pasur një gabim.");
    }
  }

  useEffect(()=>{
    apiData();
  },[])
console.log(allProduct)



const copyBoard=()=>{
   setCopied(true) 

}
	return (
		<div className="sidebar-mini skin-green-light">
		<div className="wrapper"> 
  		  <Header/> 
  		  {auth?.user?.role==="Vendor"?<VendorSidebar/>:<Sidebarr/>}
  {/* Content Wrapper. Contains page content */}
  <div className="content-wrapper">
    {/* Content Header (Page header) */}
    <section className="content-header">
      <h1>
        All Images List
        <small>it all starts here</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <a href="#">
            <i className="fa fa-dashboard" /> Home
          </a>
        </li>
        <li>
          <a href="#">Product Manage</a>
        </li>
        <li className="active">All Product</li>
      </ol>
    </section>
    {/* Main content */}
    <section className="content">
      {/* Default box */}
      <div className="box"> 
        <div className="box-body">
        	<table className="table table-bordered table-striped" id="bannerListTable">
        	  <thead>
        	    <tr>
        	  	<th className="fw-bold">#</th>
              <th>Imazh</th>
        	  	<th>Link / Target URL</th>
              <th>Data fillimi – mbarimi</th>
              <th>Main Banner</th>
              <th>Action</th>
        	  	</tr>
        	  </thead>
        	  <tbody>
            {auth?.user?.role==="Admin" && Array.isArray(allProduct) && allProduct.map((banner, idx) => (
        	  	<tr key={banner._id || idx}>
        	  		<td>{idx + 1}</td>
                <td>
                  <img src={banner?.bannerImage || banner?.bannerUrl} alt="" height="40" width="60" style={{ objectFit: 'cover' }}/>
                </td>
        	  		<td>
        	  			<span className="text-uppercase fs-1">{banner?.linkName || banner?.targetUrl || "—"}</span>
        	  		</td>
                <td>
                  {banner?.startDate ? new Date(banner.startDate).toLocaleDateString() : "—"} – {banner?.endDate ? new Date(banner.endDate).toLocaleDateString() : "—"}
                </td>
                <td>
                  {banner?.isMainBanner ? (
                    <span className="label label-success" title="Ky baner shfaqet i pari"><i className="fa fa-star"></i> Kryesor</span>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-sm btn-default"
                      onClick={() => setMainBanner(banner._id)}
                      title="Vendos si baner kryesor (i pari në slider)"
                    >
                      Bëj kryesor
                    </button>
                  )}
                </td>
        	  		<td>
        	  			<Link to={"/addbanner"} className="btn btn-default" style={{marginRight: '5px'}} title="Shto baner të ri">
        	  				<i className="fa fa-plus"></i>
        	  			</Link>
        	  			<Link to={"/editbanner/" + banner._id} className="btn btn-info" style={{marginRight: '5px'}} title="Ndrysho datë/link">
        	  				<i className="fa fa-pencil"></i>
        	  			</Link>
        	  			<button 
        	  				className="btn btn-danger" 
        	  				onClick={() => deleteBanner(banner._id)}
        	  				title="Fshi këtë baner"
        	  			>
        	  				<i className="fa fa-trash"></i>
        	  			</button>
        	  		</td>
        	  	</tr>
            ))}
            {auth?.user?.role==="Admin" && (!allProduct || allProduct.length === 0) && (
              <tr><td colSpan="6" className="text-center">Nuk ka banera. <Link to="/addbanner">Shto baner të parë</Link>.</td></tr>
            )}
        	  </tbody>
        	</table>
        </div>
        {/* /.box-body */}
        {/*<div className="box-footer">Footer</div>*/}
        {/* /.box-footer*/}
      </div>
      {/* /.box */}
    </section>
    {/* /.content */}
  </div>
  {/* /.content-wrapper */}
 


       <Footer/>
       <Tool/> 
   
  <div className="control-sidebar-bg" />
</div>

			
		</div>
	)
}